<template>
  <!-- 话务管理-录音管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <AudioBar v-if="audioInfo" :audioInfo="audioInfo"></AudioBar>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.downloadBtn"
          type="text"
          size="small"
          @click="dealOperation('download', row)"
        >
          下载
        </el-button>
        <el-button
          v-if="permissionList.collectionBtn && row.favoriteFlag == 0"
          type="text"
          size="small"
          @click="openDialog('collection', row)"
        >
          添加收藏
        </el-button>
        <el-button
          v-if="permissionList.collectionBtn && row.favoriteFlag == 1"
          type="text"
          size="small"
          @click="dealOperation('collection', row)"
        >
          取消收藏
        </el-button>
        <el-button
          v-if="permissionList.scoreBtn"
          type="text"
          size="small"
          @click="openDialog('score', row)"
        >
          评分
        </el-button>
      </template>
      <template slot="dateRangeSearch">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 100%"
        >
        </el-date-picker>
      </template>
      <template slot="radio" slot-scope="{ row }">
        <el-radio v-model="selectRowIndex" :label="row.$index" @change="rowClick(row)">
          <span>{{ '' }}</span>
        </el-radio>
      </template>
      <template slot="score" slot-scope="{ row }">
        <span> {{ row.score < 1 ? '未评分' : row.score }} </span>
      </template>
      <template slot="duration" slot-scope="{ row }">
        <span> {{ secondsToDuration(row.duration, 'chi') }} </span>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="40%"
      v-if="isDialogShow"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
    >
      <Score
        v-if="dialogType == 'score'"
        :rowData="rowData"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Score>
      <AddCollection
        v-else-if="dialogType == 'collection'"
        :rowData="rowData"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></AddCollection>
    </el-dialog>
  </basic-container>
</template>

<script>
import AudioBar from '../../components/audio-bar';
import Score from './score';
import AddCollection from './add-collection';
import { mapGetters } from 'vuex';
import { getProjectListApi } from '@/api/call-system/index';
import { getPageListApi, collectionApi } from '@/api/call-system/call-manage/recording-manage';
import { secondsToDuration } from '../../common';

export default {
  components: {
    AudioBar,
    Score,
    AddCollection,
  },
  data() {
    return {
      isPageCache: false, // 当前页面是否从后台直接显示的 true-从后台直接显示的，也就是页面是缓存状态 false-重新加载的
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      selectRowIndex: -1, // 选中的行在当前页的序号
      audioInfo: null, // 选中的行对应的数据
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        dialogClickModal: false,
        searchMenuSpan: 18,
        searchLabelWidth: 100,
        menuWidth: 160,
        column: [
          {
            label: '选择',
            prop: 'radio',
            width: 50,
            slot: true,
          },
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '坐席工号',
            prop: 'serviceNo',
            search: true,
            maxlength: 20,
            showWordLimit: true,
          },
          {
            label: '坐席姓名',
            prop: 'serviceName',
          },
          {
            label: '起止日期',
            prop: 'dateRange',
            display: false,
            showColumn: false,
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
          {
            label: '主叫号码',
            prop: 'fromPhone',
            search: true,
            maxlength: 13,
          },
          {
            label: '被叫号码',
            prop: 'toPhone',
            search: true,
            maxlength: 13,
          },
          {
            label: '综合评分',
            prop: 'score',
            slot: true,
          },
          {
            label: '开始时间',
            prop: 'callStartTime',
          },
          {
            label: '结束时间',
            prop: 'callEndTime',
          },
          {
            label: '通话时长',
            prop: 'duration',
            slot: true,
          },
          {
            label: '文件路径',
            prop: 'audioUrl',
            overHidden: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        collectionBtn: this.vaildData(
          this.permission.callSystem_callManage_recordingManage_collection,
          false
        ),
        downloadBtn: this.vaildData(
          this.permission.callSystem_callManage_recordingManage_download,
          false
        ),
        scoreBtn: this.vaildData(
          this.permission.callSystem_callManage_recordingManage_score,
          false
        ),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 从缓存状态恢复窗口显示时重新请求下数据
    if (this.isPageCache) {
      this.loadData();
    }
    this.isPageCache = true;
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    secondsToDuration: secondsToDuration,
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 390; // 表格区域初始化高度
      const searchH = 112; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.selectRowIndex = -1;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.selectRowIndex = -1;
      this.dateRange = [];
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.selectRowIndex = -1;
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.callStartTimeBegin = this.dayjs(this.dateRange[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.callStartTimeEnd = this.dayjs(this.dateRange[1]).format(
          'YYYY-MM-DD 23:59:59'
        );
      } else {
        this.searchForm.callStartTimeBegin = '';
        this.searchForm.callStartTimeEnd = '';
        this.dateRange = [];
      }
    },
    /* 行点击 */
    rowClick(row) {
      this.selectRowIndex = row.$index;
      this.audioInfo = this.tableData[this.selectRowIndex];
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 操作：下载|取消收藏 */
    dealOperation(type, row) {
      if (type == 'download') {
        window.open(row.audioUrl);
      } else if (type == 'collection') {
        collectionApi({
          id: row.id,
          favoriteFlag: 0,
        }).then(() => {
          this.$message.success('操作成功!');
          this.loadData();
        });
      }
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        collection: '添加收藏',
        score: '评分',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      this.needCloseConfirm = false;
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
